import { Card } from './card'
import { solarEnergy } from './utils/solar-energy-cards-data'

export const SolarEnergyGrid = () => {
  return (
    <div className="hidden md:flex flex-wrap justify-center gap-8 mt-12 lg:mt-[97px] mb-24 lg:mb-[151px]">
      {solarEnergy.map(item => {
        return (
          <div
            key={item.title}
            className="bg-white w-full max-w-[336px] h-[250px] rounded-lg shadow-xl pt-4 px-[26px] pb-[29px]"
          >
            <Card
              key={item.title}
              icon={item.icon}
              title={item.title}
              content={item.content}
              bulletItems={item.bulletItems}
            />
          </div>
        )
      })}
    </div>
  )
}
